import React from 'react';
import PropTypes from 'prop-types';
import { Translate, withLocalize } from 'react-localize-redux';
import { Button } from '../../../../components/widgets';
import EmptyTable from '../../../../resources/icons/empty-table.svg';
import css from './CampaignData.css';

const translatePrefix = 'STATIC.PAGES.AUDIENCES.AUDIENCE_AB_TESTING.REPORTING';

const CampaignData = ({ translate }) => {
    return (
        <div className={css.dashboardPanel}>
            <h2 className={css.panelTitle}>{translate(`${translatePrefix}.SUBITEMS_TITLES.COST_ANALYTICS`)}</h2>
            <div className={css.costAnalysisContent}>
                <div className={css.comingSoonText}>
                    <Translate id={`${translatePrefix}.METADATA.COMING_SOON_TEXT`} />
                </div>
                <EmptyTable />
                <p className={css.comingSoonTitle}>
                    <Translate id={`${translatePrefix}.METADATA.COMING_SOON_TITLE`} />!
                </p>
                <Button className={css.linkCampaignButton} disabled>
                    + {translate(`${translatePrefix}.METADATA.LINK_CAMPAIGN`)}
                </Button>
            </div>
        </div>
    );
};

CampaignData.propTypes = {
    translate: PropTypes.func,
};

export default withLocalize(CampaignData);
